import { z } from 'zod';
import { httpApi } from './basicHttpApi';
import { normalize } from '../normalize';

export const CountryZod = z.object({
  countryCode: z.string().length(2),
  countryName: z.string(),
  proxiesCount: z.number().min(0),
});
export type CountryType = z.infer<typeof CountryZod>;

export const fetchCountryList = async ({ proxyType } = { proxyType: 'mobile' })
  : Promise<Array<CountryType>> => {
  const isMobile = proxyType === 'mobile';
  const isDc = proxyType === 'datacenter';

  const countryList = await httpApi(`proxy/countries_list?isMobile=${isMobile}&isDc=${isDc}`, undefined, 'GET');
  console.log("fetchCountryList", countryList)
  const normCountryList = normalize<Array<CountryType>>(z.array(CountryZod), countryList);
  return normCountryList;
};

export const fetchCityList = async (countryCode: string) => {
  const cityList = await httpApi(`proxy/cities_list?country=${countryCode}`, undefined, 'GET');
  const normCityList = normalize<string[]>(z.string().array(), cityList);
  return normCityList;
};
